import React, { useState, useEffect } from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Start Here', path: '/' },
    { name: 'Mentorship', path: '/mentorship' },
    { name: 'Resources', path: '/resources' },
    { name: 'Success Stories', path: '/success-stories' },
    { name: 'Journal', path: '/journal' }
  ];

  return (
    <>
      <nav 
        className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
        style={{ 
          backgroundColor: isScrolled ? '#ffffff' : 'transparent',
          boxShadow: isScrolled ? '0 1px 10px rgba(0,0,0,0.05)' : 'none'
        }}
      >
        <div className="max-w-7xl mx-auto px-8 py-5">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link 
              to="/"
              className="text-sm tracking-[0.2em] font-light italic transition-opacity hover:opacity-60"
              style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
            >
              Farzeen Khan
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-10">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-xs tracking-wider font-light transition-all hover:opacity-60"
                  style={{ 
                    color: location.pathname === link.path ? '#8b7355' : '#1a1a1a'
                  }}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* Social Icons */}
            <div className="hidden lg:flex items-center gap-4">
              <a 
                href="https://instagram.com/itsfarzeenkhan" 
                target="_blank" 
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-60"
                style={{ color: '#1a1a1a' }}
              >
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a 
                href="https://facebook.com/itsfarzeenkhan" 
                target="_blank" 
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-60"
                style={{ color: '#1a1a1a' }}
              >
                <Facebook size={18} strokeWidth={1.5} />
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2"
              style={{ color: '#1a1a1a' }}
            >
              <div className="space-y-1.5">
                <div 
                  className="w-6 h-0.5 transition-all duration-300"
                  style={{ 
                    backgroundColor: '#1a1a1a',
                    transform: isMobileMenuOpen ? 'rotate(45deg) translateY(6px)' : 'none'
                  }}
                />
                <div 
                  className="w-6 h-0.5 transition-all duration-300"
                  style={{ 
                    backgroundColor: '#1a1a1a',
                    opacity: isMobileMenuOpen ? 0 : 1
                  }}
                />
                <div 
                  className="w-6 h-0.5 transition-all duration-300"
                  style={{ 
                    backgroundColor: '#1a1a1a',
                    transform: isMobileMenuOpen ? 'rotate(-45deg) translateY(-6px)' : 'none'
                  }}
                />
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div 
          className="lg:hidden overflow-hidden transition-all duration-500"
          style={{ 
            maxHeight: isMobileMenuOpen ? '400px' : '0',
            backgroundColor: '#ffffff'
          }}
        >
          <div className="px-8 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-sm tracking-wider font-light py-2 transition-all hover:opacity-60"
                style={{ 
                  color: location.pathname === link.path ? '#8b7355' : '#1a1a1a'
                }}
              >
                {link.name}
              </Link>
            ))}
            
            <div className="flex items-center gap-4 pt-4" style={{ borderTop: '1px solid #e8e6e1' }}>
              <a 
                href="https://instagram.com/itsfarzeenkhan" 
                target="_blank" 
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-60"
                style={{ color: '#1a1a1a' }}
              >
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a 
                href="https://facebook.com/itsfarzeenkhan" 
                target="_blank" 
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-60"
                style={{ color: '#1a1a1a' }}
              >
                <Facebook size={18} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navigation;
